/* eslint-disable @typescript-eslint/no-floating-promises */
import { Injectable, signal } from "@angular/core";
import { Network } from "@capacitor/network";

@Injectable({
  providedIn: "root",
})
export class NetworkService {
  public status = signal<boolean>(false);

  constructor() {
    this.initNetworkListener();
  }

  private async initNetworkListener() {
    try {
      const networkStatus = await Network.getStatus();
      this.status.set(networkStatus.connected);
      await Network.addListener("networkStatusChange", (status) => {
        this.status.set(status.connected);
      });
    } catch (error) {
      console.error("NetworkService Error:", error);
    }
  }

  public getCurrentStatus(): boolean {
    return this.status();
  }
}
